const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

const revealables = document.querySelectorAll("[data-reveal]")

if (reduceMotion || !("IntersectionObserver" in window)) {
  revealables.forEach((el) => el.classList.add("is-revealed"))
} else {
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-revealed")
          obs.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.15 }
  )

  revealables.forEach((el) => observer.observe(el))
}
